import { LaneType } from 'common-types';
import { INTERACTION_STATES } from 'constants-interactions';
import { ReservableUnitTypesEnum } from './ReservableFeatureProperties';

export type QRCodeStatusType = (typeof INTERACTION_STATES)[number];

export type QRCodeCheckinFeatureRuleType = {
  _id: LaneType.UUID;
  fromStatus: QRCodeStatusType;
  toStatus: QRCodeStatusType | null;
};

export type QRCodeCheckinFeatureCheckInOutRuleType =
  QRCodeCheckinFeatureRuleType & {
    content?: LaneType.Content;
    autoStatus: QRCodeStatusType | null;
    autoStatusUnits: number;
    autoStatusUnitType: ReservableUnitTypesEnum;
  };

export type QRCodeCheckinFeatureProperties = {
  rules: QRCodeCheckinFeatureRuleType[];
  checkIn: QRCodeCheckinFeatureCheckInOutRuleType | null;
  checkOut: QRCodeCheckinFeatureCheckInOutRuleType | null;
};

export enum QRCodeCheckinFeatureEventTypesEnum {
  CheckIn = 'check-in',
  CheckOut = 'check-out',
}
